import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private isVisibleSubject = new BehaviorSubject<boolean>(false);

  get isVisible$() {
    return this.isVisibleSubject.asObservable();
  }

  show() {
    this.isVisibleSubject.next(true);
  }

  hide() {
    this.isVisibleSubject.next(false);
  }
}
